module.exports = __webpack_public_path__ + "img/SZ0009.69485ca.jpg";